import React, {Fragment} from 'react';
import {dateData} from "../components/form/DateTimeInput";
import {sendRequest} from "./request";
import classNames from 'classnames';
import ComponentLoader from "../components/form/ComponentLoader";
import ComponentConfig from "../components/form/ComponentConfig";
import {loadComponentById} from "./components";
import Icon from "../components/form/Icon";
import parse_url from "locutus/php/url/parse_url";
import {unparse_url} from "./url/unparse_url";
import {get, set} from "./dotutils";
import OperationListStock from "../components/editors/OperationList/OperationListStock";
import BigNumber from "bignumber.js";
import {localOptionFilter} from "./filters";

export const BarcodeFormatter = (input) => {
    if (input.indexOf("ö") !== -1 && !isNaN(input.replace(/ö/g, ''))) {
        input = input.replace(/ö/g, '0');
    }
    if (!isNaN(input)) {
        return parseInt(input);
    }
    return input;
}

export const EmailFormatter = (email) => {
    return email && <a href={"mailto:" + email} target="_blank">{email}</a>;
}

export const TelnumFormatter = (telnum) => {
    return telnum && <a href={"tel:" + telnum} target="_blank">{telnum}</a>;
}

export const AddressFormatter = (address) => {
    return address && ((address.postcode ? address.postcode + " " : "") + (address.city ? address.city : "") + ((address.postcode || address.city) && address.address ? ", " : "") + (address.address ? address.address : ""));
}

export const UpdatedByFormatter = (updated_by) => {
    return updated_by && updated_by.name;
}

export const UserFormatter = (user) => {
    return user && user.name;
}

export const PercentFormatter = (value) => {
    return <span className={"percent"}>{(value || 0) + " %"}</span>;
}

// TODO majd ezt tényleg currency-re csinálni
export const CurrencyFormatter = (price, currency = null) => {
    if (price !== null && price !== undefined && price !== "") {
        price = Math.round(new BigNumber(price).multipliedBy(10).dividedBy(10).toNumber());
        // https://medium.com/coding-at-dawn/is-negative-zero-0-a-number-in-javascript-c62739f80114
        // HAHAHAHAHAHHAHAHAAA
        if (price === -0 && !Object.is(+0, price)) {
            price = +0;
        }
        return <span className={"currency"}>{price.toLocaleString("hu-HU") + " Ft"}</span>;
    }
    return <span/>;
}

// TODO majd ezt tényleg currency-re csinálni
export const SignedCurrencyFormatter = (price, currency = null) => {
    if (price !== null && price !== undefined && price !== "") {
        price = Math.round(new BigNumber(price).multipliedBy(10).dividedBy(10).toNumber());
        // https://medium.com/coding-at-dawn/is-negative-zero-0-a-number-in-javascript-c62739f80114
        // HAHAHAHAHAHHAHAHAAA
        if (price === -0 && !Object.is(+0, price)) {
            price = +0;
        }
        const sign = price < 0 ? <span className="sign minus">-</span> : (price > 0 ?
            <span className="sign plus">+</span> : null);
        const clazz = (price < 0 ? "minus" : (price > 0 ? "plus" : ""));
        price = Math.abs(price).toLocaleString("hu-HU");
        return <span className={"currency signed " + clazz}>{sign}{price + " Ft"}</span>;
    }
    return <span/>;
}

export const UnitFormatter = (amount, unit = "db") => {
    if (typeof amount === "object" && amount !== null && amount !== undefined) {
        return amount;
    }
    unit = unit || "db";
    return <span className={"unit"}>{(amount !== null && amount !== undefined && amount !== '' && (amount || 0) + (unit && " " + unit)) || ""}</span>;
}

export const DiscountFormatter = (discount) => {
    return <span className="discount">{parseFloat(discount || 0).toFixed(2) + "%"}</span>;
}

export const OptionFormatter = (option) => {
    return option && option.optionlabel;
}

const optionFormats = {};
const optionRequest = {};

class OptionFormat extends React.Component {

    constructor(props) {
        super(props);
        this.mounted = true;
        const then = (data) => {
            const items = {};
            data.items.map((option) => {
                items[option.optionid] = option
            });
            optionFormats[props.option] = items;
            if (this.mounted) {
                this.forceUpdate();
            }
        };
        if (!optionFormats[props.option] && !optionRequest[props.option]) {
            optionRequest[props.option] = sendRequest({
                option: "componentlist",
                component: "option",
                itemsperpage: 0,
                optionname: props.option
            }, {showError: false});
            optionRequest[props.option].then(then);
            optionRequest[props.option].catch(() => {
                delete optionRequest[props.option];
            });
        } else if (optionRequest[props.option]) {
            optionRequest[props.option].then(then);
            optionRequest[props.option].catch(() => {
                delete optionRequest[props.option];
            });
        }
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    render() {
        return (
            ((optionFormats[this.props.option] || {})[this.props.value] || {}).optionlabel || this.props.def || this.props.value || null
        );
    }
}

export const remoteOptionFormatter = (option, def) => {
    return (value) => {
        return <OptionFormat def={def} option={option} value={value} />
    }
}

export const localOptionFormatter = (options, def, key = "key", label = "label") => {
    return (value) => {
        return (options.find((option) => option[key] + "" === "" +value) || {})[label] || null;
    }
}

export const LanguageFormatter = (language) => {
    return language && language.hu;
}

let languageFormats = {};
let languageRequest = null;
let languageRequestFilter = {};
const defaultBase = "defaultLanguageBaseID" + (new Date().getTime());

export class LanguageFormat extends React.Component {
    constructor(props) {
        super(props);
        this.mounted = true;
        const base = (props.base || defaultBase);
        const key = props.id + "@" + base;
        const then = (data) => {
            const items = {};
            data.items.map((language) => {
                items[language.id] = {...(languageFormats[language.id] || {}), [language.base || defaultBase]: language};
            });
            languageFormats = items;
            delete languageRequestFilter[base];
            if (this.mounted) {
                this.forceUpdate();
            }
        };
        if (!languageRequestFilter[base]) {
            languageRequestFilter[base] = {};
        }
        if (!(languageFormats[props.id] || {})[props.base || defaultBase]) {
            languageRequestFilter[base] = {id: [...(languageRequestFilter[base].id || []), props.id].filter((value, index, self) => self.indexOf(value) === index), base: [...(languageRequestFilter[base].base || []), base].filter((value, index, self) => self.indexOf(value) === index)};
            const ids = languageRequestFilter[base].id;
            const bases = languageRequestFilter[base].base;
            languageRequest && languageRequest.abort();
            languageRequest = sendRequest({
                option: "componentlist",
                component: "language",
                itemsperpage: 0,
                filter: [{field: "id", operator: "in", value: ids},{filters: [{field: "base", value: bases, operator: "in"},{field: "base", operator: "isnull"}], operator: "OR"}],
            }, {showError: false});
            languageRequest.then(then);
            languageRequest.catch(() => {
                delete languageRequestFilter[base];
            });
        }
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    render() {
        return (
            ((languageFormats[this.props.id] || {})[this.props.base] || {}).hu || ((languageFormats[this.props.id] || {})[defaultBase] || {}).hu || this.props.def || this.props.id || null
        );
    }
}

export const remoteLanguageFormatter = (base) => {
    return (token, def) => {
        return <LanguageFormat id={token} base={base} def={def} />
    }
}

const componentNames = {};

export class ComponentName extends React.Component {

    constructor(props) {
        super(props);
        if (!(componentNames[this.props.component] || {})[this.props.component_id]) {
            this.state = {
                name: null
            };
            this.componentDidUpdate({}, this.props);
        } else {
            this.state = {
                name: componentNames[this.props.component][this.props.component_id]
            };
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.component !== prevProps.component || this.props.component_id !== prevProps.component_id) {
            if (!(componentNames[this.props.component] || {})[this.props.component_id]) {
                this.load && this.load.abort();
                this.load = loadComponentById(this.props.component, this.props.component_id, ["displayname", "name", "title"]);
                this.load.then((component) => {
                    if (!componentNames[this.props.component]) {
                        componentNames[this.props.component] = {};
                    }
                    componentNames[this.props.component][this.props.component_id] = component.displayname || component.name || component.title;
                    this.setState({
                        name: componentNames[this.props.component][this.props.component_id]
                    });
                });
            } else {
                this.setState({
                    name: componentNames[this.props.component][this.props.component_id]
                });
            }
        }
    }

    render() {
        return (
            this.state.name || this.props.children
        );
    }
}

export const DateFormatter = (date) => (date && dateData(date, true).momentValue.format("YYYY.MM.DD.")) || date;
export const DateTimeFormatter = (date) => (date && dateData(date, true).momentValue.format("YYYY.MM.DD. HH:mm:ss")) || date;

const componentFormats = {};
const componentRequest = {};

class ComponentFormat extends React.Component {
    constructor(props) {
        super(props);
        if (props.onlyThis) {
            const then = (data) => {
                const items = {};
                data.items.map((component) => {
                    items[component[props.idfield || props.componentConfig.idfield]] = component
                });
                componentFormats[props.component] = {...(componentFormats[props.component] || {}), ...items};
                this.forceUpdate();
            };
            if (!this.request) {
                this.request = sendRequest({
                    option: "componentlist",
                    component: props.component,
                    itemsperpage: 0,
                    filter: [{field: props.componentConfig.idfield, value: props.value}]
                }, {showError: false});
                this.request.then(then);
                this.request.catch(() => {
                    delete this.request;
                });
            } else if (this.request) {
                this.request.then(then);
                this.request.catch(() => {
                    delete this.request;
                });
            }
        } else {
            const then = (data) => {
                const items = {};
                data.items.map((component) => {
                    items[component[props.idfield || props.componentConfig.idfield]] = component
                });
                componentFormats[props.component] = {...(componentFormats[props.component] || {}), ...items};
                this.forceUpdate();
            };
            if (!componentFormats[props.component] && !componentRequest[props.component]) {
                componentRequest[props.component] = sendRequest({
                    option: "componentlist",
                    component: props.component,
                    itemsperpage: 0,
                }, {showError: false});
                componentRequest[props.component].then(then);
                componentRequest[props.component].catch(() => {
                    delete componentRequest[props.component];
                });
            } else if (componentRequest[props.component]) {
                componentRequest[props.component].then(then);
                componentRequest[props.component].catch(() => {
                    delete componentRequest[props.component];
                });
            }
        }
    }

    render() {
        return (
            ((componentFormats[this.props.component] || {})[this.props.value] || {})[this.props.labelfield || "name"] || this.props.value || null
        );
    }
}

export const remoteComponentFormatter = ({component, labelfield = null, idfield = null}, onlyThis = false) => {
    return (value) => {
        return <ComponentConfig componentName={component} loader={() => null}>
            <ComponentFormat component={component} value={value} idfield={idfield} labelfield={labelfield} onlyThis={onlyThis} />
        </ComponentConfig>;
    }
}

export class LocationSelect extends React.Component {

    static view = ["name", "address"];

    render() {
        return (
            <div className="location-select">
                <div className="details">
                    <div className="name">{this.props.name}</div>
                    <div className="address">{AddressFormatter(this.props.address)}</div>
                </div>
            </div>
        );
    }
}

export class NewsletterSelect extends React.Component {

    static view = ["name", "id", "subject"];

    render() {
        return (
            <div className="newsletter-select">
                <div className="details">
                    <div className="name">{this.props.name} <span className="id">(#{this.props.id})</span></div>
                    <div className="subject">{this.props.subject}</div>
                </div>
            </div>
        );
    }
}

export const optionsTemplate = (component) => {
    if (component === "partner") {
        return PartnerSelect;
    } else if (component === "product") {
        return ProductSelect;
    } else if (component === "Newsletter") {
        return NewsletterSelect;
    } else if (component === "location") {
        return LocationSelect;
    } else if (component === "person") {
        return PersonSelect;
    }
};

export class ProductSelect extends React.Component {

    static view = ["displayname", "barcode", "sku", "listprice", "cover_image", "tradename", "sortiments"];

    render() {
        return (
            <div className="product-select">
                <div className="image">
                    {this.props.cover_image && <img src={this.props.cover_image.url} />}
                </div>
                <div className="details">
                    <div className="name">{this.props.displayname}</div>
                    <div className="tradename">{(this.props.tradename || {}).name}</div>
                    <div className="spec">
                        {!!this.props.barcode && <span className="barcode">(Vonalkód: {this.props.barcode})</span>}
                        {!!this.props.sku && <span className="sku">(Sku: {this.props.sku})</span>}
                        {!!this.props.listprice && <span className="price">{this.props.listprice} Ft</span>}
                        {Array.isArray(this.props.sortiments) && !!this.props.sortiments.length && <div className="sortiments">Szortimentek: {this.props.sortiments.map((sortiment, idx) => <span key={idx} className="sortiment">{sortiment.name}</span>)}</div>}
                    </div>
                </div>
            </div>
        );
    }
}

export class ProductSelectSmall extends React.Component {

    static view = ["displayname", "listprice", "cover_image"];

    render() {
        return (
            <div className="product-select">
                <div className="image">
                    {this.props.cover_image && <img src={this.props.cover_image.url} />}
                </div>
                <div className="details">
                    <div className="name">{this.props.displayname}</div>
                    <div className="spec">
                        {!!this.props.listprice && <span className="price">{this.props.listprice} Ft</span>}
                    </div>
                </div>
            </div>
        );
    }
}

export class AgentSelect extends React.Component {

    static view = ["name", "address"];

    render() {
        return (
            <div className="user-select">
                <div className="name">{this.props.name}</div>
                <div className="address">{AddressFormatter(this.props.address)}</div>
            </div>
        );
    }
}

export class PartnerSelect extends React.Component {

    static view = ["name", "address", "taxid"];

    render() {
        if (!this.props.partner_id) {
            return this.props.name;
        }
        const address = AddressFormatter(this.props.address);
        return (
            <div className="partner-select">
                <div className="name">{this.props.name}<span className={classNames("taxid", {"not-set": !this.props.taxid})}>({this.props.taxid || "Nincs megadva adószám!"})</span></div>
                <div className={classNames("address", {"not-set": !address})}>{address || "Nincs megadva számlázási cím!"}</div>
            </div>
        );
    }
}

export class PersonSelect extends React.Component {

    static view = ["name", "email"];

    render() {
        return (
            <div className="person-select">
                <div className="name">{this.props.name}</div>
                <div className="email">{this.props.email}</div>
            </div>
        );
    }
}

export const productTooltip = (idfield) => (value, rowData) => {
    return <ComponentLoader componentName="product" componentId={get(rowData, idfield)} view={ProductSelect.view}>
        {(data) => <ProductSelect {...data.values}/>}
    </ComponentLoader>
}


export const ProductName = (idfield) => (value, row) => {
    const href = parse_url(window.location.href);
    href.fragment = "/?option=product&id=" + get(row, idfield);
    return <Fragment>{value} <span className="product-actions"><OperationListStock productId={get(row, idfield)} product={row} /><a href={unparse_url(href)} target="_blank"><Icon lib="fas" name="external-link-alt" tooltip="Termék adatlap" /></a></span></Fragment>;
}

export const ProductColumn = (idfield, ifFn) => ({
    header: 'Megnevezés',
    sortable: true,
    filterable: true,
    renderer: (...args) => ifFn ? ifFn(ProductName(idfield), ...args) : ProductName(idfield)(...args),
    tooltip: (...args) => ifFn ? ifFn(productTooltip(idfield), ...args) : productTooltip(idfield)(...args)
});

export const localOptionColumn = (options) => ({
    filterable: localOptionFilter(options),
    renderer: localOptionFormatter(options),
});

const componentTranslate = {
    "invoice": "Számla",
    "stocktransfer": "Szállítás",
    "purchase": "Tranzakció",
    "StoreOrderClaim": "Reklamáció",
    "WriteOff": "Leírás",
    "storeorder": "Raktári rendelés",
    "MoneyTransfer": "Fizetés",
    "TransactionPayment": "Fizetés"
};

export const ComponentOptions = Object.keys(componentTranslate).map((key) => ({key, label: componentTranslate[key]}));

export const ComponentFormatter = ({component, componentId = null}) => {
    if (!componentId) {
        return remoteLanguageFormatter('')(component, componentTranslate[component] || component);
    }
    return <ComponentName component={component} component_id={componentId}>{remoteLanguageFormatter('')(component)}{" (#" + componentId + ")"}</ComponentName>
}